import React from 'react'
import { useForm } from 'react-hook-form'
import * as R from 'ramda'

const ROOT_API_ERROR = 'root.apiError'

export const useFormApiError = (state, onApiError) => {
  const { apiError } = state

  React.useEffect(() => {
    if (!R.isNil(apiError)) {
      onApiError(apiError)
    }
  }, [apiError, onApiError])
}

export const useFormReset = (state, onFormReset) => {
  const { shouldReset } = state

  React.useEffect(() => {
    if (shouldReset) {
      onFormReset()
    }
  }, [onFormReset, shouldReset])
}

export const useControlledForm = ({
  defaultValues,
  mode = 'onSubmit',
  resolver,
  reValidateMode = 'onChange',
  values,
  handleFormData,
}) => {
  const {
    control,
    formState,
    getValues,
    handleSubmit,
    reset,
    setError,
    setValue,
    watch,
    trigger,
  } = useForm({
    defaultValues,
    mode,
    resolver,
    reValidateMode,
    values,
  })

  const isDirtyOrInvalid = R.or(formState.isDirty, !R.isEmpty(formState.errors))

  const handleFormApiError = React.useCallback(
    ({ message, type }) => setError(ROOT_API_ERROR, { type, message }),
    [setError],
  )

  const handleFormReset = React.useCallback(
    (options = {}) => {
      reset(defaultValues, { ...options })
    },
    [defaultValues, reset],
  )

  return {
    control,
    formState,
    getValues,
    handleFormApiError,
    handleFormReset,
    handleFormSubmit: handleSubmit(handleFormData),
    setValue,
    watch,
    trigger,
    isDirtyOrInvalid,
  }
}
